





























































import { Vue, Component, Ref, PropSync, Watch } from 'vue-property-decorator'
import { FindConfiguracaoDeCupomUseCase } from '@/usecases'
import moment from 'moment'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { CupomDeDesconto, Venda } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class DialogoDeCupons extends Vue {
	@PropSync('value', { type: Object, default: null }) venda!: Venda
	@Ref() formDeAplicacaoDosCupons!: HTMLFormElement
	@Ref() campoDeCupom!: HTMLInputElement

	findConfiguracaoDeCupomUseCase = new FindConfiguracaoDeCupomUseCase()
	cupomLido: CupomDeDesconto | null = null
	aplicandoCupom = false
	mostraDialogo = false
	codigoDoCupom = ''

	mostrar() {
		this.mostraDialogo = true
	}

	@Watch('mostraDialogo', { immediate: true })
	onChangeMostraDialogo(mostraDialogo: boolean) {
		if (!mostraDialogo) return
		setTimeout(() => {
			this.campoDeCupom.focus()
		})
	}

	get cupomDeDesconto(){
		return this.venda.cuponsDeDesconto
	}

	async aplicarCupom() {
		if (!this.codigoDoCupom) {
			AlertModule.setError('Informe um cupom válido')
			return
		}

		const cupomEstaAplicado = this.venda.cuponsDeDesconto.some(
			({ codigo }) => codigo === this.codigoDoCupom,
		)

		if (cupomEstaAplicado) {
			AlertModule.setError('O cupom já foi aplicado nesta venda.')
			this.aplicandoCupom = false
			return
		}

		try {
			this.aplicandoCupom = true
			this.cupomLido = await this.findConfiguracaoDeCupomUseCase.findByCodigo(this.codigoDoCupom)
		} catch (error) {
			AlertModule.setError(error)
			this.aplicandoCupom = false
			return
		}

		if (moment().isAfter(moment(this.cupomLido.dataFinalVigencia, 'YYYY-MM-DD HH:mm:ss'))) {
			AlertModule.setError(`Este cupom expirou em ${dateTimeToPtBrFormat(this.cupomLido.dataFinalVigencia || '')}`)
			this.aplicandoCupom = false
			return
		}

		const cupomJaAplicado = this.venda.cuponsDeDesconto.some(
			({ id }) => id === this.cupomLido?.id,
		)
		if (cupomJaAplicado) {
			AlertModule.setError('Cupom já foi aplicado à esta venda')
			this.aplicandoCupom = false
			return
		}

		AlertModule.setSuccess('Cupom aplicado com sucesso')
		this.aplicandoCupom = false

		this.$emit('aplicarCupomNaVenda', this.cupomLido)
		this.fecharDialogo()
	}

	fecharDialogo() {
		setTimeout(() => {
			this.formDeAplicacaoDosCupons.resetValidation()
			this.codigoDoCupom = ''
		})
		this.mostraDialogo = false
	}
}

